import MetaEmpresa from './MetaEmpresa';

export default MetaEmpresa;